

import { createRoot } from 'react-dom/client';
import Layout from './Layout';




// Block Directory
document.addEventListener('DOMContentLoaded', () => {
	const productSwipeEl = document.getElementById('bslMainLayout');

	renderPlugin(productSwipeEl);
});


const renderPlugin = (el) => {
	if (el) {
		const attributes = JSON.parse(el?.dataset.attributes);
		const { items = [
			{ url: "https://i.ibb.co.com/hY4y7cM/3.jpg" }, { url: "https://i.ibb.co.com/9wVDgjj/2.jpg" }, { url: "https://i.ibb.co.com/RNRj2fy/1.jpg" }], settings = { slidesView: { desktop: 3, tablet: 2, mobile: 1 } }, height = 400, sliderPlay = { isAutoPlay: false, duration: 2.5 } } = attributes;

		const allAttributs = { items, settings, height, sliderPlay };
		createRoot(el).render(<>
			<Layout {...allAttributs} />
		</>);

		el?.removeAttribute('data-attributes');
	}
}

